export default "__VITE_ASSET__BLORHgJT__"